module.exports = __webpack_public_path__ + "static/media/virtual-tour-icon.9d73c0c2.svg";